import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKxDiamantCureusBuExportStatus: 'idle',
    startProcessKxDiamantCureusBuExportError: undefined as any,
    loadUserParamsProcessKxDiamantCureusBuExportStatus: 'idle',
    loadUserParamsProcessKxDiamantCureusBuExportError: undefined as any,

    processKxDiamantCureusBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKxDiamantCureusBuExport = createAsyncThunk('processKxDiamantCureusBuExportSlice/startProcessKxDiamantCureusBuExport', async ({ processKxDiamantCureusBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKxDiamantCureusBuExport/`,
        prepareData(processKxDiamantCureusBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKxDiamantCureusBuExportStatus } = getState().processKxDiamantCureusBuExportSlice
        return startProcessKxDiamantCureusBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKxDiamantCureusBuExport = createAsyncThunk('processKxDiamantCureusBuExportSlice/loadUserParamsProcessKxDiamantCureusBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKxDiamantCureusBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKxDiamantCureusBuExportStatus } = getState().processKxDiamantCureusBuExportSlice
        return loadUserParamsProcessKxDiamantCureusBuExportStatus !== 'pending'
    }
})

const ProcessKxDiamantCureusBuExportSlice = createSlice({
    name: 'processKxDiamantCureusBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessKxDiamantCureusBuExport: (state) => {
            state.job = undefined
            state.startProcessKxDiamantCureusBuExportError = undefined
        },
        resetstartProcessKxDiamantCureusBuExportError: (state) => {
            state.startProcessKxDiamantCureusBuExportError = undefined
        },
        resetloadUserParamsProcessKxDiamantCureusBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKxDiamantCureusBuExportError = undefined
        },
        resetloadUserParamsProcessKxDiamantCureusBuExportError: (state) => {
            state.loadUserParamsProcessKxDiamantCureusBuExportError = undefined
        },
        removeFromProcessKxDiamantCureusBuExportListById: (state, action) => {
            state.processKxDiamantCureusBuExportList = state.processKxDiamantCureusBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKxDiamantCureusBuExportListByIds: (state, action) => {
            state.processKxDiamantCureusBuExportList = state.processKxDiamantCureusBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKxDiamantCureusBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKxDiamantCureusBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKxDiamantCureusBuExportList = []
            state.startProcessKxDiamantCureusBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKxDiamantCureusBuExport.pending, (state) => {
            state.startProcessKxDiamantCureusBuExportStatus = 'pending'
            state.startProcessKxDiamantCureusBuExportError = undefined
        })
        builder.addCase(startProcessKxDiamantCureusBuExport.fulfilled, (state, action) => {
            state.startProcessKxDiamantCureusBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKxDiamantCureusBuExport.rejected, (state, action) => {
            state.startProcessKxDiamantCureusBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKxDiamantCureusBuExportError = action.error.message
            } else {
                state.startProcessKxDiamantCureusBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKxDiamantCureusBuExport.pending, (state) => {
            state.loadUserParamsProcessKxDiamantCureusBuExportStatus = 'pending'
            state.loadUserParamsProcessKxDiamantCureusBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKxDiamantCureusBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKxDiamantCureusBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKxDiamantCureusBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessKxDiamantCureusBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKxDiamantCureusBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessKxDiamantCureusBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKxDiamantCureusBuExport,
    resetstartProcessKxDiamantCureusBuExportError,
    resetloadUserParamsProcessKxDiamantCureusBuExport,
    resetloadUserParamsProcessKxDiamantCureusBuExportError,
    removeFromProcessKxDiamantCureusBuExportListById,
    removeFromProcessKxDiamantCureusBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKxDiamantCureusBuExportSlice.actions
export default ProcessKxDiamantCureusBuExportSlice.reducer
